import React, { useRef, useEffect } from "react";
import { Autoplay, Pagination } from "swiper/modules";
import UIBody from "../../../components/ui/UIBody";
import { Link } from "react-router-dom";
import useApiCallHooks from "../../../hooks/useApiCallHooks";
const ProgramPage = () => {
  const swiperRef = useRef(null);

 const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
useEffect(() => {
  callAPI("get", "student-programs");
}, []);

  return (
    <UIBody
    loading={loading}
      content={
        <div>
          <section class="cta__area-four">
            <div class="container">
              <div class="row justify-content-center">
                <div class="col-xl-10">
                  <div class="cta__inner-wrap mt-2" style={{
                        background: 'linear-gradient(90deg, rgba(2, 0, 36, 1) 0%, rgba(9, 9, 121, 1) 22%, rgba(0, 212, 255, 1) 100%)',

    borderRadius: '20px',
    // padding: '40px',
    color: '#fff' // optional: ensures text is readable on dark background
  }}>
                    <div class="cta__img-three tg-svg " >
                      <img
                        src="https://html.themegenix.com/skillgro/assets/img/others/h8_cta_img.png"
                        alt="img"
                      />
                      <span
                        class="svg-icon"
                        id="cta-svg"
                        data-svg-icon="assets/img/others/h8_cta_img_shape.svg"
                      ></span>
                    </div>
                    <div class="cta__content-three cta__content-four" >
                      <div class="content__left">
                        <h2 class="title text-center">Start Your Learning Journey Today</h2>
                        <p>
                          Discover expert-led courses designed to launch your
                          career in tech, business, and more — all in one place
                        </p>
                      </div>
                      {/* <a href="/login" class="btn arrow-btn">
                        GET sTARTED{" "}
                        <img
                          src="assets/img/icons/right_arrow.svg"
                          alt=""
                          class="injectable"
                        />
                      </a> */}
                    </div>
                    <img
                      src="assets/img/others/h8_cta_shape.svg"
                      alt="shape"
                      class="shape"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className="section__title text-center mb-40 mt-5">
            <span className="sub-title">Growth Zone</span>
            <h2 className="title">Find the Right Program for You</h2>
            <p className="desc">
              Find the perfect course to match your career goals. From tech to
              business, our expert-led programs offer practical learning paths
              for every ambition.
            </p>
          </div>

          <section className="all-courses-area py-4">
            <div className="container">
              <div className="row">
                {responce?.data?.map((course) => (
                  <div
                    className="col-12 col-md-6 col-lg-4 mb-4"
                    key={course.id}
                  >
                    <div className="courses__item shine__animate-item me-1">
                      <div className="courses__item-thumb">
                       <Link to={`/program/details/${course.slug}`}>
                          <img
                            src={course.image}
                            alt="course"
                            className="img-fluid"
                          />
                        </Link>
                      </div>
                      <div className="courses__item-content">
                        <ul className="courses__item-meta list-wrap">
                          <li className="courses__item-tag">
                            <Link to={`/program/details/${course.slug}`}>{course.tag}</Link>
                          </li>
                          <li className="avg-rating">
                            <i className="fas fa-star"></i> ({course.rating}{" "}
                            Reviews)
                          </li>
                        </ul>
                        <h5 className="title m-0">
                           <Link to={`/program/details/${course.slug}`}>{course.name}</Link>
                        </h5>
                        <p className="courses_mini_titile my-2">
                                                   {course.description}

                        </p>
                        <div className="d-flex justify-content-between align-items-center gap-2 flex-wrap">
                          <div className="courses__item_point">
                            <i className="fas fa-book px-2"></i>
                            {course.duration}
                          </div>
                          <div className="courses__item_point">
                            <i className="fas fa-tasks px-2"></i>
                            {course.activities}
                          </div>
                        </div>
                        <ul className="list-unstyled d-flex flex-column gap-1 py-2">
                          {course.learning_points.map((learning_points, index) => (
                            <li
                              key={index}
                              className="d-flex align-items-center"
                            >
                              <i className="fas fa-check-circle text-success me-2"></i>
                              <span>{learning_points}</span>
                            </li>
                          ))}
                        </ul>

                        <div className="">
                      <Link to={`/program/details/${course.slug}`}>
  <button className="btn w-100 text-white rounded">
    Enroll Now
  </button>
</Link>

                        
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section
            class="about-area-six about__bg"
            data-background="assets/img/bg/h8_about_bg.jpg"
          >
            <div class="container">
              <div class="row align-items-center justify-content-center">
                <div class="col-lg-6 col-md-10">
                  <div class="about__images-six">
                    <img
                      src="https://img.freepik.com/premium-photo/young-asian-indian-college-students-reading-books-studying-laptop-preparing-exam-working-group-project-while-sitting-grass-staircase-steps-college-campus_466689-7729.jpg?uid=R185717575&ga=GA1.1.974985297.1742381629&semt=ais_hybrid&w=740"
                      alt="img"
                    />
                    {/* <img src="assets/img/others/h8_about_img02.jpg" alt="img" data-aos="fade-left" data-aos-delay="400" /> */}
                    <div
                      class="about__success"
                      data-aos="fade-up"
                      data-aos-delay="400"
                    >
                      <div class="icon">
                        <i class="skillgro-diploma-1"></i>
                      </div>
                      <div class="content">
                        <h2 class="title">86%</h2>
                        <span>Course Success</span>
                      </div>
                    </div>
                    <div class="shape">
                      <img
                        src="assets/img/others/h8_about_img_shape.svg"
                        alt="shape"
                        class="alltuchtopdown"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="about__content-six">
                    <div class="section__title mb-15">
                      <span class="sub-title">Get More About Us</span>
                      <h2 class="title">
                        Launch Your Career with
                        <span class="position-relative">
                          <svg
                            x="0px"
                            y="0px"
                            preserveAspectRatio="none"
                            viewBox="0 0 209 59"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4.74438 7.70565C69.7006 -1.18799 136.097 -2.38304 203.934 4.1205C207.178 4.48495 209.422 7.14626 208.933 10.0534C206.793 23.6481 205.415 36.5704 204.801 48.8204C204.756 51.3291 202.246 53.5582 199.213 53.7955C136.093 59.7623 74.1922 60.5985 13.5091 56.3043C10.5653 56.0924 7.84371 53.7277 7.42158 51.0325C5.20725 38.2627 2.76333 25.6511 0.0898448 13.1978C-0.465589 10.5873 1.61173 8.1379 4.73327 7.70565"
                              fill="currentcolor"
                            />
                          </svg>
                          Industry-Ready
                        </span>
                        IT Training
                      </h2>
                    </div>
                    <p>
                      Our expert-led programs are designed for individuals
                      looking to build professional skills, gain certifications,
                      and land high-demand tech jobs.
                    </p>
                    <ul class="about__info-list list-wrap">
                      <li class="about__info-list-item">
                        <i class="flaticon-angle-right"></i>
                        <p class="content">
                          Learn from Experienced Industry Trainers
                        </p>
                      </li>
                      <li class="about__info-list-item">
                        <i class="flaticon-angle-right"></i>
                        <p class="content">
                          100% Online and Flexible Learning Options
                        </p>
                      </li>
                      <li class="about__info-list-item">
                        <i class="flaticon-angle-right"></i>
                        <p class="content">
                          Certification-Focused Programs to Boost Your Resume
                        </p>
                      </li>
                    </ul>
                  
                  </div>
                </div>
              </div>
            </div>
            <div class="about__shape-wrap">
              <img
                src="assets/img/others/h8_about_shape01.svg"
                alt="shape"
                data-aos="fade-down-right"
                data-aos-delay="400"
              />
              <img
                src="assets/img/others/h8_about_shape02.svg"
                alt="shape"
                data-aos="fade-up-left"
                data-aos-delay="400"
              />
            </div>
          </section>

      
        </div>
      }
    />
  );
};

export default ProgramPage;






